import { render } from "./g-login-activate-mail.vue?vue&type=template&id=79967451&ts=true"
import script from "./g-login-activate-mail.vue?vue&type=script&lang=tsx"
export * from "./g-login-activate-mail.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__